import { IReportColumnDef } from '../../shared-models/reports/report-column.interface';

/**
 * Return the default-selected column ids from a report column definition list.
 */
export function getDefaultSelectedReportColumnIds(columns: IReportColumnDef[]): string[] {
  return columns
    .filter((column: IReportColumnDef) => column.defaultSelected)
    .map((column: IReportColumnDef) => column.id);
}

/**
 * Resolve selected columns in the order of the source definition.
 * Returns an empty array when none of the requested ids are valid.
 */
export function resolveSelectedReportColumns(
  columns: IReportColumnDef[],
  selectedColumnIds: string[],
): IReportColumnDef[] {
  if (!selectedColumnIds.length) {
    return [];
  }
  const selected = new Set(selectedColumnIds);
  return columns.filter((column: IReportColumnDef) => selected.has(column.id));
}

/**
 * Whether at least one selected column id matches a known column definition.
 */
export function hasValidSelectedReportColumns(
  columns: IReportColumnDef[],
  selectedColumnIds: string[],
): boolean {
  return resolveSelectedReportColumns(columns, selectedColumnIds).length > 0;
}

/**
 * Apply a new selection order while preserving unknown ids only when they match definitions.
 * Used when the column-select modal returns an ordered list.
 */
export function orderReportColumnsBySelection(
  columns: IReportColumnDef[],
  selectedColumnIds: string[],
): IReportColumnDef[] {
  const byId = new Map(columns.map((column: IReportColumnDef) => [column.id, column]));
  const ordered: IReportColumnDef[] = [];
  for (const id of selectedColumnIds) {
    const column = byId.get(id);
    if (column) {
      ordered.push(column);
    }
  }
  return ordered;
}
